"use strict";
var flyoutTimeline = null;

// .closest
if (!Element.prototype.matches) {
Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
Element.prototype.closest = function(s) {
  var el = this;

  do {
    if (el.matches(s)) return el;
    el = el.parentElement || el.parentNode;
  } while (el !== null && el.nodeType === 1);
  return null;
};
} 

// throttle
function throttle(delay, fn) {
var last, deferTimer;
return function() {
  var context = this, args = arguments, now = +new Date;
  if(last && now < last + delay)       {
    clearTimeout(deferTimer);
    deferTimer = setTimeout(function() { last = now; fn.apply( context, args ); }, delay);
  } else {
    last = now;
    fn.apply(context, args);
  }
};
}

function getTransitionDuration (element) {
return parseFloat(window.getComputedStyle(element).getPropertyValue('transition-duration')) * 1000;
}

window.oaBackdrop = (function () {

var backdrop = document.getElementById('oa-bckdrp19'),
    classBackdropHidden = 'oa-bckdrp19--hidden',
    classBackdropSidenav = 'oa-bckdrp19--sidenav',
    classBackdropSearch = 'oa-bckdrp19--search',
    classBackdropFlyout = 'oa-bckdrp19--flyout';

function hide () {
  backdrop.classList.add(classBackdropHidden);
  backdrop.classList.remove(classBackdropSidenav);
  backdrop.classList.remove(classBackdropSearch);
  backdrop.classList.remove(classBackdropFlyout);
}

function show () {
  backdrop.classList.remove(classBackdropHidden);
}

function showForSidenav () {
  backdrop.classList.add(classBackdropSidenav);
  backdrop.classList.remove(classBackdropSearch);
  backdrop.classList.remove(classBackdropFlyout);
  show();
}

function showForSearch () {
  backdrop.classList.remove(classBackdropSidenav);
  backdrop.classList.add(classBackdropSearch);
  backdrop.classList.remove(classBackdropFlyout);
  show();
}

function showForFlyout () {
  backdrop.classList.remove(classBackdropSidenav);
  backdrop.classList.remove(classBackdropSearch);
  backdrop.classList.add(classBackdropFlyout);
  show();
}

return {
  hide: hide,
  show: show,
  showForSidenav: showForSidenav,
  showForSearch: showForSearch,
  showForFlyout: showForFlyout
}

})();


// TODO: Measure scroll bar width and set it as padding on body?

window.oaMenu = (function (menu, before, after) {

var classMenuMobileOpen = 'oa-header__sidenav--open',
    classHtmlMenuOpened = 'oa-menumobile--opened',
    classHtmlNoOverflow = 'oa-nooverflow';

var html = document.documentElement,
    backdrop = document.getElementById('oa-bckdrp19');

var pagecenter = document.getElementById('page-center');

var isOpen = false;

var duration = getTransitionDuration(pagecenter);
var timer;

function resetTimeout() {
  if (timer) {
    clearTimeout(timer);
  }
}

function showMenu () {
  isOpen = true;
  resetTimeout();
  menu.classList.add(classMenuMobileOpen);
  if (typeof before === 'function') {
    before.call(null, isOpen); 
  }
  html.classList.add(classHtmlNoOverflow);
  html.classList.add(classHtmlMenuOpened);
  window.oaBackdrop.showForSidenav();
  timer = setTimeout(function () {
    if (typeof after === 'function') {
      after.call(null, isOpen); 
    }
  }, duration);
}

function hideMenu () {
  isOpen = false;
  resetTimeout();
  if (typeof before === 'function') {
    before.call(null, isOpen); 
  }
  html.classList.remove(classHtmlMenuOpened);
  window.oaBackdrop.hide();
  timer = setTimeout(function () {
    html.classList.remove(classHtmlNoOverflow);
    menu.classList.remove(classMenuMobileOpen);
    if (typeof after === 'function') {
      after.call(null, isOpen); 
    }
  }, duration);
}

function toggleMenu () {
  isOpen = !isOpen;
  if (isOpen) {
    showMenu();
  } else {
    hideMenu();
  }
}

function onBackdropClicked (event) {
  event.preventDefault();
  isOpen = true;
  toggleMenu();
}

document.addEventListener('DOMContentLoaded', function (event) {
  backdrop.addEventListener('click', onBackdropClicked);
});


return {
  show: showMenu,
  hide: hideMenu,
  toggle: toggleMenu,
};

});



window.oaHeader = (function () {

var header = document.getElementById('oa-hdr19'),
    headerMain = document.querySelector('.oa-hdr19-main'),
    headerSidenav = document.getElementById('header-sidenav');

//
//
//
var gradientScroll = (function () {
  var disabled = false;
  var headerTop = header.querySelector('.oa-hdr19-top');
  var heroBanner = document.querySelector('.oa-hero-banner.oa-hero-banner--offset .oa-hero-banner__content > *');
  
  var classGradient = 'oa-hdr19-top--gradient';
  var offset;
  
  function updateOffset() {
    if (disabled) {
      return;
    }
    offset = heroBanner.offsetTop + heroBanner.clientHeight - (2 * headerTop.clientHeight);
  }
  
  function updateHeaderGradient() {
    if (disabled) {
      return; 
    }
    if (window.pageYOffset >= offset) {
      headerTop.classList.remove(classGradient);
    } else {
      headerTop.classList.add(classGradient);
    }
  }

  if (headerTop.classList.contains(classGradient) && heroBanner != null) {
    updateOffset();
    updateHeaderGradient();
    window.addEventListener('resize', function (event) {
      updateOffset();
    }, false);
    window.addEventListener('scroll', function (event) {
      updateHeaderGradient();
    }, false);
    }
  
  return {
    disable: function () {
      disabled = true; 
    },
    enable: function () {
      disabled = false; 
    }
  }
})();

//
// MENU TOGGLE
//
var menuToggle = (function () {

  var banner = document.getElementById('oa-hdr19-banner');

  var classHeaderToggled = 'oa-hdr19-top__toggle--toggled',
      toggle;

  var pagecenter = document.getElementById('page-center'),
      classPagecenterOntop = 'page-center--ontop';
  var y;

  var onResize = throttle(150, function () {
    window.oaHeaderSidenav.hide();
  });

  function afterToggle (isOpen) {
    if (isOpen) {
      setTimeout(function () {
        window.addEventListener('resize', onResize, { capture: true, passive: true });
      }, 16);
    } else {
      window.removeEventListener('resize', onResize, { capture: true, passive: true });
      setTimeout(function () {
        pagecenter.classList.remove(classPagecenterOntop);
        sidenav.resetActivePanel();
      }, 0);
    }
  }

  function beforeToggle (isOpen) {
    if (isOpen) {
    y = window.scrollY || window.pageYOffset;
    var h = window.innerHeight;
    gradientScroll.disable();

      /*
    const isFirefox = typeof InstallTrigger !== 'undefined';
    if (isFirefox) {
      y = 22;
    }*/


    header.style.setProperty('top', y + 'px', 'important');
    // header.style.setProperty('position', 'absolute', 'important');
    pagecenter.classList.add(classPagecenterOntop);

    pagecenter.style.position = 'fixed';
    pagecenter.style.top = (-y) + 'px';
    pagecenter.style.height = (y + h) + 'px';

   

    toggle.classList.add(classHeaderToggled);
  } else {
    toggle.classList.remove(classHeaderToggled);
    pagecenter.style.position = '';
    pagecenter.style.height = '';
    pagecenter.style.top = '';
    header.style.top = '';


    window.scrollTo(0, y);
    setTimeout(function () {
      var restoredY = window.scrollY || window.pageYOffset;
      if (restoredY !== y) {
        window.scrollTo(0, y);
      }
    }, 0);
    gradientScroll.enable();
  }
}
  window.oaHeaderSidenav = window.oaMenu(headerSidenav, beforeToggle, afterToggle);

  function setupScrollBackground(open) {
        const pagecenter = document.getElementById('page-center');
        const classPagecenterOntop = 'page-center--ontop';

        if (open) {
          const y = window.scrollY || window.pageYOffset;
          const h = window.innerHeight;

            
           

          pagecenter.dataset.scrollY = y;
          pagecenter.classList.add(classPagecenterOntop);

       
    const isFirefox = typeof InstallTrigger !== 'undefined';
         if (isFirefox) {
          pagecenter.style.position = 'sticky';
         }else {
          pagecenter.style.position = 'fixed';
        }
          pagecenter.style.top = (-y) + 'px';
          pagecenter.style.height = (y + h) + 'px';
        } else {
          const y = parseInt(pagecenter.dataset.scrollY || 0, 10);

          pagecenter.classList.remove(classPagecenterOntop);
          pagecenter.style.position = '';
          pagecenter.style.height = '';
          pagecenter.style.top = '';
          window.scrollTo(0, y);

          pagecenter.removeAttribute('data-scroll-y');
        }
}

window.oaHeaderDownnav = function(toggle) {
  const classHeaderToggled = 'oa-hdr19-top__toggle--toggled';
  const classMobileOpen = 'oa-downmenumobile--opened';
  const classMobileTransparent = 'oa-hdr19--transparent';
  const htmlEl = document.documentElement;
  const downnav = document.querySelector('.oa-header__collapse');
  const tabs = downnav.querySelectorAll('.oa-header__collapse-tab');
  const panels = downnav.querySelectorAll('.oa-header__collapse-submenu');
  const subMenues = document.querySelectorAll('.oa-header__collapse-under-submenu');
  const targetHeight = window.innerHeight - 56 + 'px';
  const headerItems = downnav.querySelectorAll('.oa-header__collapse--menu-item');

  // Animate Downnav Open/Close
  toggle.classList.toggle(classHeaderToggled);
  htmlEl.classList.toggle(classMobileOpen);
  if(document.getElementById('oa-hdr19').classList.contains(classMobileTransparent)){
  document.getElementById('oa-hdr19').classList.toggle(classMobileTransparent);
}
  const isOpening = htmlEl.classList.contains(classMobileOpen);

  const tl = gsap.timeline({ defaults: { overwrite: true } });



  if (isOpening) {
    setupScrollBackground(true);
    downnav.style.display = 'block';
    subMenues.forEach(el => {
      el.removeAttribute('style');
    });

    panels.forEach((panel, i) => {
      if (i === 0) panel.style.display = 'block';
      else panel.style.display = 'none';
    });

    // Initial states for tabs and panels
    gsap.set(tabs, { opacity: 0 });
    tabs.forEach(tab => {
      gsap.set(tab.querySelector('.oa-header__collapse-tab-underline'), { width: 0 });
    });
    panels.forEach((panel, i) => {
      gsap.set(panel.children, { opacity: 0, x: -20 });
    });
    document.querySelector('.oa-header__collapse-tab').classList.add('is-active');
    tl.fromTo(
      downnav,
      { height: 0 },
      {
        height: targetHeight,
        duration: 0.45,
        ease: 'power2.out'
      }
    )
    .to(
      tabs,
      {
        opacity: 1,
        duration: 0.19,
        stagger: 0.05,
        ease: 'power1.out'
      },
      "-=0.25"
    )
    .to(
      tabs[0].querySelector('.oa-header__collapse-tab-underline'),
      {
        width: "100%",
        duration: 0.35,
        ease: "power2.out"
      },
      "-=0.16"
    )
    .to(
      panels[0].children,
      {
        opacity: 1,
        x: 0,
        duration: 0.28,
        ease: "power2.out"
      },
      "-=0.18"
    );
    tl.call(() => {
      window.tlCallback();
    });
  } else {

    
    setupScrollBackground(false);
    // Animate out, then collapse
    const activeTab = downnav.querySelector('.oa-header__collapse-tab.is-active');
    if (activeTab) {
      tl.to(
        activeTab.querySelector('.oa-header__collapse-tab-underline'),
        { width: 0, duration: 0.10, ease: "power2.in" },
        0
      );
    }
    panels.forEach(panel => {
      tl.to(
        panel.children,
        {
          opacity: 0,
          x: -10,
          duration: 0.05,
          stagger: { each: 0.01, from: 'end' },
          ease: 'power1.in'
        },
        0
      );
    });
    tl.to(
      downnav,
      {
        height: 0,
        duration: 0.20,
        ease: 'power2.in',
        onComplete: () => { downnav.style.display = 'none'; }
      },
      0.30
    );
    tl.call(() => {
      window.tlCallback();
      document.querySelectorAll(".oa-header__collapse-tab").forEach(tab => {
         tab.removeAttribute("style");
         tab.classList.remove('is-active')
        });
      headerItems.forEach(el => {
        el.classList.remove('is-active');
      });
    });


/*reset*/
   

    
  }

  // --- Tab Switching with Animations ---
  tabs.forEach(tab => {
    tab.onclick = function() {
      if (tab.classList.contains('is-active')) return;

      // Reset tabs
      tabs.forEach(t => {
        t.classList.remove('is-active');
        gsap.set(t.querySelector('.oa-header__collapse-tab-underline'), { width: 0 });
      });
      tab.classList.add('is-active');

      // Panels
      const target = tab.dataset.tab;
      panels.forEach(panel => panel.style.display = 'none');
      const newPanel = downnav.querySelector(`.oa-header__collapse-submenu[data-panel="${target}"]`);
      newPanel.style.display = 'block';

      // Reset submenu item states
      gsap.set(newPanel.children, { opacity: 0, x: -20 });

      // Animate tab underline
      gsap.to(tab.querySelector('.oa-header__collapse-tab-underline'), {
        width: "100%",
        duration: 0.36,
        ease: "power2.out"
      });

      // Animate submenu items in
      gsap.to(newPanel.children, {
        opacity: 1,
        x: 0,
        duration: 0.24,
        ease: "power2.out"
      });
    }
  });


};

window.oaHeaderCollapsibleInit = function() {
  if(!$('html').hasClass('header-version--a')){return;}


  const items = document.querySelectorAll('.oa-header__collapse--menu-item');

function closeSubmenu(submenu) {
  if (!submenu) return;
  gsap.killTweensOf(submenu);
  gsap.timeline()
    .to(submenu, {
      opacity: 0,
      x: -20,
      duration: 0.15,
      ease: 'power2.in'
    })
    .to(submenu, {
      height: 0,
      duration: 0.2,
      ease: 'power2.in',
      onComplete: () => {
        submenu.style.display = 'none';
        submenu.style.height = '';
      }
    });
}

function openSubmenu(submenu) {
  if (!submenu) return;
  gsap.killTweensOf(submenu);
  submenu.style.display = 'block';
  gsap.set(submenu, { opacity: 0, x: -20, height: 0 });
  gsap.timeline()
    .to(submenu, {
      height: 'auto',
      duration: 0.2,
      ease: 'power2.out'
    })
    .to(submenu, {
      opacity: 1,
      x: 0,
      duration: 0.10,
      ease: 'power2.out'
    });
}

items.forEach(item => {
  item.addEventListener('click', () => {
    const target = item.getAttribute('data-target');
    const submenu = document.querySelector(`.oa-header__collapse-under-submenu[data-under="${target}"]`);

    const wasActive = item.classList.contains('is-active');

    if (wasActive) {
      // If clicking the active item, just close it and stop (don't reopen)
      item.classList.remove('is-active');
      closeSubmenu(submenu);
      return;
    }

    // Otherwise, close others first
    document.querySelectorAll('.oa-header__collapse--menu-item.is-active')
      .forEach(activeItem => activeItem.classList.remove('is-active'));

    document.querySelectorAll('.oa-header__collapse-under-submenu')
      .forEach(sm => {
        if (sm !== submenu) closeSubmenu(sm);
      });

    // Open the clicked one
    item.classList.add('is-active');
    openSubmenu(submenu);
  });
});




  window.tlCallback = function () {
    const collapseFirstCategory = false;
      if(collapseFirstCategory){
        const activeTab = document.querySelector('.oa-header__collapse-tab.is-active');

        const tabName = activeTab.getAttribute('data-tab');
        const targetPanel = document.querySelector(`.oa-header__collapse-submenu[data-panel="${tabName}"] .oa-header__collapse--menu-item`);
        if (targetPanel) {
          targetPanel.click();
        }
      }
    }
}


  document.addEventListener('DOMContentLoaded', function () {
    window.oaHeaderCollapsibleInit();
    toggle = document.getElementById('headertoggle');
    toggle.addEventListener('click', function (event) { 
      event.preventDefault();
      if($('html').hasClass('header-version--a')){
        //console.log('show menu a');
        window.oaHeaderDownnav(this);
      }else{
        window.oaHeaderSidenav.toggle();
      }
    });
  }, { passive: true });

})();

 

//
// SIDENAV
//
var sidenav = (function () {

  var selectorSidenavPanelLinks = '.oa-header__sidenav__main__link[href*="#"]',
      selectorSidenavPanel = '.oa-header__sidenav__main__panel',
      classSidenavLinkPrev = 'oa-header__sidenav__main__link--prev',
      classSidenavLinkNext = 'oa-header__sidenav__main__link--next',
      classSidenavPanelHidden = 'oa-header__sidenav__main__panel--hidden',
      classSidenavPanelOpened = 'oa-header__sidenav__main__panel--opened',
      classSidenavPanelSubopened = 'oa-header__sidenav__main__panel--subopened';

  var toplink = document.getElementById('headersidenav-toplink');

  var duration;
  var timer;

  function resetTimeout() {
    if (timer) {
      clearTimeout(timer);
    }
  }

  function getCurrentPanel (link) {
    return link.closest(selectorSidenavPanel);
  }

  function getTargetPanel (link) {
    return document.getElementById(link.getAttribute('href').substr(1));
  }

  function showPrevPanel (panel, prevPanel) {
    resetTimeout();

    prevPanel.classList.remove(classSidenavPanelHidden);

    setTimeout(function () {
      panel.classList.remove(classSidenavPanelOpened);
      prevPanel.classList.remove(classSidenavPanelSubopened);
      prevPanel.classList.add(classSidenavPanelOpened);
    }, 16);  

    timer = setTimeout(function () {
      panel.scrollTop = 0;
      panel.classList.add(classSidenavPanelHidden);
    }, duration);
  }

  function showNextPanel (panel, nextPanel) {
    resetTimeout();

    nextPanel.classList.remove(classSidenavPanelHidden);

    setTimeout(function () {
      panel.classList.add(classSidenavPanelSubopened);
      nextPanel.classList.add(classSidenavPanelOpened);
    }, 16);

    timer = setTimeout(function () {
      panel.scrollTop = 0;
      panel.classList.add(classSidenavPanelHidden);
    }, duration);
  }

  function isPrevLink (link) {
    return link.classList.contains(classSidenavLinkPrev);
  }

  function isNextLink (link) {
    return link.classList.contains(classSidenavLinkNext);
  }

  function onLinkClicked (event) {
    event.preventDefault();
    if (isPrevLink(this)) {
      showPrevPanel(getCurrentPanel(this), getTargetPanel(this));
    } else if (isNextLink(this)) {
      showNextPanel(getCurrentPanel(this), getTargetPanel(this));
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    duration = getTransitionDuration(document.querySelector(selectorSidenavPanel));
    var links = document.querySelectorAll(selectorSidenavPanelLinks);
    Array.prototype.slice.call(links).forEach(function (link) {
      link.addEventListener('click', onLinkClicked);
    });
  }, { passvie: true });

  return {
    resetActivePanel: function () {
      var mainPanel = document.getElementById('sidenav-main');
      mainPanel.classList.remove(classSidenavPanelSubopened);
      mainPanel.scrollTop = 0;
      mainPanel.classList.remove(classSidenavPanelHidden);
      var otherPanels = document.querySelectorAll(selectorSidenavPanel);
      Array.prototype.slice.call(otherPanels).forEach(function (panel) {
        if (panel === mainPanel) {
          return; 
        }
        panel.scrollTop = 0;
        panel.classList.add(classSidenavPanelHidden);
        panel.classList.remove(classSidenavPanelOpened);
        panel.classList.remove(classSidenavPanelSubopened);
      });
    }
  }

})();

//
// CHOOSE REGION
//  
var chooseRegion = (function () {

  var selectorHeaderMainCountryIcon = '.oa-hdr19-main__right__link__countryicon',
      selectorHeaderMainTransparentCountryIcon = '.oa-hdr19-main__top__link__countryicon',
      selectorHeaderSidenavCountryIcon = '.oa-header__sidenav__main__countryicon';

  function setCountryIcon (selector, src) {
    var icon = document.querySelector(selector);
    if (!icon) {
      return;
    }
    icon.dataset.src = src;
    icon.src = src;
    icon.style.opacity = 1;
  }

  return {
    setCountryIcon: function (src) {
      setCountryIcon(selectorHeaderMainCountryIcon, src);
      setCountryIcon(selectorHeaderMainTransparentCountryIcon, src);
      setCountryIcon(selectorHeaderSidenavCountryIcon, src);
    }, 
  }

})();

//
// CART BADGE
// 
var cartBadge = (function () {
  var badge = document.getElementById('header-cart-badge'),
      badgeText = document.getElementById('header-cart-badge-text'),
      badgeCheck = document.getElementById('header-cart-badge-check'),
      classBadgeVisible = 'oa-hdr19-top__cart-badge--visible',
      classBadgeCheckVisible = 'oa-hdr19-top__cart-badge__check--visible',
      classBadgeCheckMovingFast = 'oa-hdr19-top__cart-badge__check--movingfast',
      classBadgeCheckMovingSlow = 'oa-hdr19-top__cart-badge__check--movingslow';

  var timer;

  function resetTimeout() {
    if (timer) {
      clearTimeout(timer);
    }
  }

  function updateText (count) {
    badgeText.innerText = count;
    if (parseInt(count) > 0 && !badge.classList.contains(classBadgeVisible)) {
      badge.classList.add(classBadgeVisible);
    } else if (parseInt(count) === 0) {
      badge.classList.remove(classBadgeVisible);
    }
  }

  function loadCount () {
    return axios.get('/cart.json', { headers: { 'Cache-Control': 'no-cache, no-store', 'Pragma': 'no-cache', 'Expires': 0 } }).then(function (response) {
      var itemCount = response.data.item_count || 0;
      var totalPrice = response.data.total_price || 0;
      updateText(itemCount);
      return { 
        itemCount: itemCount,
        totalPrice: totalPrice,
      };
    });
  }

  function showCheck (targetElement, onFinish, quickadd) {
    resetTimeout();
    badgeCheck.classList.remove(classBadgeCheckVisible);
    badgeCheck.classList.remove(classBadgeCheckMovingFast);
    badgeCheck.classList.remove(classBadgeCheckMovingSlow);
    badgeCheck.style.top = '';
    badgeCheck.style.right = '';

    if (typeof targetElement.get !== 'undefined') {
      targetElement = targetElement.get(0);
    }
    var badgeCheckRect = badgeCheck.getBoundingClientRect();
    var targetRect = targetElement.getBoundingClientRect();
    var width = window.innerWidth;
    var positionTop = Math.round(targetRect.top + targetRect.height/2 - badgeCheckRect.height/2 - badgeCheckRect.top + parseInt(window.getComputedStyle(badgeCheck).getPropertyValue('top')));
    var badgeRightTmp = parseInt(window.getComputedStyle(badgeCheck).getPropertyValue('right'));
    var positionRight1 = Math.round(width - targetRect.left - targetRect.width - (width - badgeCheckRect.left) + badgeCheckRect.width/2 + badgeRightTmp);
    var positionRight2 = Math.round(positionRight1 + targetRect.width/2);

    badgeCheck.style.top = parseInt(positionTop) + 'px';
    badgeCheck.style.right = parseInt(!!quickadd ? positionRight2 : positionRight1) + 'px';
    timer = setTimeout(function () {
      badgeCheck.classList.add(classBadgeCheckVisible);
      badgeCheck.classList.add(classBadgeCheckMovingFast);
      setTimeout(function() {
        badgeCheck.style.right = parseInt(positionRight2) + 'px';
      }, 0);
      timer = setTimeout(function () {
        badgeCheck.classList.add(classBadgeCheckMovingSlow);
        badgeCheck.classList.remove(classBadgeCheckMovingFast);
        setTimeout(function () {
          badgeCheck.style.top = '';
          badgeCheck.style.right = '';
        }, 0);
        timer = setTimeout(function () {
          loadCount().then(function () {
            badgeCheck.classList.remove(classBadgeCheckVisible);
            badgeCheck.classList.remove(classBadgeCheckMovingSlow);
            if (typeof onFinish === 'function') {
              onFinish();
            }
          });
        }, 750);
      }, 250);
    }, 300);
  }

  return {
    showCheck: showCheck,
    loadCount: loadCount
  };

})();

//
// FLYOUT
//
var mainFlyoutMenu = (function () {

  // var backdrop = document.getElementById('oa-bckdrp19-flyout');
  // var classBackdropShow = 'oa-bckdrp19--show';

  var selectorMainLink = 'a.oa-hdr19-main__left__link',
      selectorFlyoutLink = 'a.oa-hdr19-main__flyout__left__link',
      selectorFlyoutGroup = '.oa-hdr19-main__flyout__right',
      classFlyout = 'oa-hdr19-main__flyout',
      classMainLinkActive = 'oa-hdr19-main__left__link--active',
      classFlyoutActive = 'oa-hdr19-main__flyout--active',
      classFlyoutLinkActive = 'oa-hdr19-main__flyout__left__link--active',
      classFlyoutGroupActive = 'oa-hdr19-main__flyout__right--active',    
      mouseOutDelay = 50;

  var mainLeftLinks,
      mouseOutTimer;


    

  function getFlyoutForLeftLink (element) {
    return element.dataset.href && element.dataset.href.substr(0, 1) === '#' && document.getElementById(element.dataset.href.substr(1));
  }

  function isFlyoutForLeftLink (flyout) {
    return flyout && flyout.classList.contains(classFlyout);
  }

  function getFlyoutLeftLinks (flyout) {
    return Array.prototype.slice.call(flyout.querySelectorAll(selectorFlyoutLink)); 
  }

  function getFlyoutRightGroups (flyout) {
    return Array.prototype.slice.call(flyout.querySelectorAll(selectorFlyoutGroup));
  }

  function resetMainTimeout () {
    if (mouseOutTimer) { 
      clearTimeout(mouseOutTimer);
    }
  }

  function setMainLeftActive (element) {
    var flyout = getFlyoutForLeftLink(element);
    if (!isFlyoutForLeftLink(flyout)) {
      return;
    }

    document.querySelectorAll(selectorFlyoutLink).forEach(link => {
        link.classList.remove(classFlyoutLinkActive);
    });


    
    element.classList.add(classMainLinkActive);
    flyout.classList.add(classFlyoutActive);
    const flyoutWrapper = document.querySelector('.oa-hdr19-main__flyout.oa-hdr19-main__flyout--active'); 
    const targetLink = flyout.querySelector(selectorFlyoutLink);

    if(document.querySelector('html').classList.contains('header-version--a')){
    document.querySelectorAll(selectorFlyoutGroup).forEach(el => {
      el.classList.remove(classFlyoutGroupActive);
    });
  }

    if (flyoutWrapper && flyout && targetLink) {
      targetLink.classList.add(classFlyoutLinkActive);

      const leftLinks = flyout.querySelectorAll(".oa-hdr19-main__flyout__left__link");
      const underline = targetLink.querySelector(".underline-bar");
      const innerLeft = flyout.querySelector(".oa-hdr19-main__flyout__inner-left");

      const groupEls = flyout.querySelectorAll(selectorFlyoutGroup);
      const mainFlyoutContainer = document.querySelector('.oa-hdr19-main__left');
      



      if (flyoutTimeline) {
        document.querySelectorAll(".oa-hdr19-main__flyout").forEach(flyout => {
         gsap.set(flyout, { clearProps: "all" });
        });
        flyoutTimeline.kill();
        flyoutTimeline = null;
      }

        document.querySelectorAll(".oa-hdr19-main__flyout__inner-left").forEach(link => {
         link.removeAttribute("style");
        });

        document.querySelectorAll(".oa-hdr19-main__flyout__right--img").forEach(img => {
         img.querySelector('.oa-picture-wrapper').removeAttribute("style");
         img.classList.remove('oa-hdr19-main__flyout__right--img--no-animation');
        });

        /*document.querySelectorAll('.oa-hdr19-main__flyout__right--img--animation').forEach(el => {
              el.classList.remove('oa-hdr19-main__flyout__right--img--no-animation');
            });
            */
        

        const items = document.querySelectorAll('#flyout-shop .oa-hdr19-main__flyout__right');



        flyoutTimeline = gsap.timeline({
          onComplete: () => {
          }
        });

        

      // 1. Animate flyout container (slide down & fade)
      if (mainFlyoutContainer && !mainFlyoutContainer.classList.contains('oa-hdr19-main__left--active')) {
        mainFlyoutContainer.classList.add('oa-hdr19-main__left--active');
        flyoutWrapper.querySelector('.oa-hdr19-main__flyout__right').classList.add('oa-hdr19-main__flyout__right--active');
        flyoutTimeline.fromTo(
          flyoutWrapper,
          { opacity: 0, y: -20, display: "none" },
          {
            opacity: 1,
            y: 0,
            display: "block", 
            duration: 0.4,
            ease: "power2.out",
            onComplete: () => {
              if (!flyoutWrapper.matches(':hover')|| true) {
                //flyoutWrapper.querySelector('.oa-hdr19-main__flyout__right').classList.add('oa-hdr19-main__flyout__right--active');
              }
            }
          }
        );
      }else{
        flyoutWrapper.querySelector('.oa-hdr19-main__flyout__right').classList.add('oa-hdr19-main__flyout__right--active');
      }

      // 2. Animate all left links
      if(false){
      flyoutTimeline.fromTo(
        leftLinks,
        { opacity: 0, x: -20 },
        {
          opacity: 1,
          x: 0,
          duration: 0.4,
          ease: "power2.out",
          stagger: 0.1
        }
      );
    }
      // 3. Underline bar animation
      if (underline && false) {
        flyoutTimeline.fromTo(
          underline,
          { width: "0%", opacity: 0 },
          { width: "100%", opacity: 1, duration: 0.2, ease: "power2.out" }
        );
      }

      // 4. Inner content area animation (right side)
      if (innerLeft && false) {
        innerLeft.style.visibility = "visible";
        flyoutTimeline.fromTo(
          innerLeft,
          { opacity: 0, x: -20 },
          { opacity: 1, x: 0, duration: 0.4, ease: "power2.out" }
        );
      }
      
    }

  }

  function removeMainLeftActive () {
    mainLeftLinks.forEach(function (e) { 
      var flyout = getFlyoutForLeftLink(e);
      if (!isFlyoutForLeftLink(flyout)) {
        return;
      }
      e.classList.remove(classMainLinkActive);
      flyout.classList.remove(classFlyoutActive);
      if (flyoutTimeline) {
          gsap.set(flyout, { clearProps: "all" });
      }
    });
   

  }

  function setFlyoutLeftActive (flyoutRightGroups, element) {
    var href = element.dataset.href || element.getAttribute('href');
    flyoutRightGroups.forEach(function (e) {
      if (e.hasAttribute('id')) {
        if (e.id === href.substr(1)) {
          e.classList.add(classFlyoutGroupActive);
        } else if (e.classList.contains(classFlyoutGroupActive)) {
          e.classList.remove(classFlyoutGroupActive);
        }
      }
    });
    if (href.substr(0, 1) === '#') {
      element.classList.add(classFlyoutLinkActive);
      /*
      gsap.fromTo(
        ".oa-hdr19-main__flyout__left__link--active .underline-bar",
        { width: "0%", opacity: 0 },
        { width: "100%", opacity: 1, duration: 0.4, ease: "power2.out" }
      );
      */
    }
  }

  function removeFlyoutLeftActive (flyoutLeftLinks, except) {
    flyoutLeftLinks.forEach(function (e) {
      if (e !== except && e.classList.contains(classFlyoutLinkActive)) { 
        e.classList.remove(classFlyoutLinkActive); 
      }
    });
  }

  // TODO: use one flyout and toggle children visibility

  function onMainLeftLinkMouseEnter (element) {
    resetMainTimeout();
    removeMainLeftActive();
    setMainLeftActive(element);
    
    // backdrop.classList.add(classBackdropShow);
  }

  function onMainLeftLinkMouseLeave (flyoutLeftLinks, flyoutRightGroups) {
    resetMainTimeout();
    mouseOutTimer = setTimeout(function () {
      resetMainTimeout();
      removeMainLeftActive();
      if (flyoutRightGroups && flyoutLeftLinks && flyoutLeftLinks[0]) {
        removeFlyoutLeftActive(flyoutLeftLinks, null);
        setFlyoutLeftActive(flyoutRightGroups, flyoutLeftLinks[0]);
      }
      document.querySelector('.oa-hdr19-main__left').classList.remove('oa-hdr19-main__left--active');
      // backdrop.classList.remove(classBackdropShow);
     
    }, mouseOutDelay);
  }


  document.addEventListener('DOMContentLoaded', function () {
    mainLeftLinks = Array.prototype.slice.call(document.querySelectorAll(selectorMainLink));
    mainLeftLinks.forEach(function (element) {
      element.addEventListener('mouseenter', onMainLeftLinkMouseEnter.bind(null, element), { passive: true });
      element.addEventListener('mouseleave', onMainLeftLinkMouseLeave, { passive: true });
      element.addEventListener('click', function (event) {
        if (isMobile()) {
          event.preventDefault();
          return;
        }
      });

      var flyout = getFlyoutForLeftLink(element);
      if (!isFlyoutForLeftLink(flyout)) {
        return;
      }

      var flyoutLeftLinks = getFlyoutLeftLinks(flyout);
      var flyoutRightGroups = getFlyoutRightGroups(flyout);

      flyout.addEventListener('mouseenter', resetMainTimeout, { passive: true });
      flyout.addEventListener('mouseleave', onMainLeftLinkMouseLeave.bind(null, flyoutLeftLinks, flyoutRightGroups), { passive: true });

      flyoutLeftLinks.forEach(function (element) {
        element.addEventListener('mouseenter', function () {
          resetMainTimeout();
          removeFlyoutLeftActive(flyoutLeftLinks, element);
          setFlyoutLeftActive(flyoutRightGroups, element);
        }, { passive: true });
        if (!element.dataset.href) {
          element.addEventListener('click', function (event) {
            event.preventDefault();
          });
        }
      });
    });
  }, { passive: true });

  return {};
})();

//
// BOTTOM SLIDER
//
var bottomSlider = (function () {
  var sliderId = '#oa-hdr19-bottom-swiper';
  var bottomEl = document.getElementById(sliderId.slice(sliderId.indexOf('#') + 1));

  if (!bottomEl) {
    return; 
  }

  var bottomElContainer = bottomEl.querySelector('.oa-hdr19-bottom__container');
  var swiper;

  function initSlider () {
    var isSlider = bottomEl.className.indexOf('swiper-container-initialized') !== -1;
    if (isSlider) {
      return;
    }
    swiper = new Swiper(bottomEl, {
      on: {
        init: function () {
          var swiper = this;
          var removeSlideIndices = [];
          swiper.slides.each(function (index, slide) {
            if (window.getComputedStyle(slide).getPropertyValue('display') !== 'none') {
              return; 
            }
            removeSlideIndices.push(parseInt(swiper.$(slide).attr('data-swiper-slide-index'), 10));
          });
          swiper.removeSlide(removeSlideIndices);
          swiper.update();
        },
      },
      navigation: {
        nextEl: sliderId + ' + .oa-hdr19-bottom__slider__nav .oa-hdr19-bottom__slider__nav-next',
        prevEl: sliderId + ' + .oa-hdr19-bottom__slider__nav .oa-hdr19-bottom__slider__nav-prev',
        disabledClass: 'oa-hdr19-bottom__slider__nav--disabled',
        hiddenClass: 'oa-hdr19-bottom__slider__nav--disabled'
      },
      slidesPerView: 1,
      spaceBetween: 1,
      loop: true,
      speed: 500,
      roundLengths: true, //prevent blurry text
      mousewheel: {
        forceToAxis: true,
        releaseOnEdges: true,
        invert: true
      },
      autoplay: {
        delay: 5000
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    window.GeoRedirect.fetchData(function (data) {
      var classList = document.documentElement.classList;
      var shipping1El, shipping2El;

      if (classList.contains('oa-de')) {
        switch (data.country_code) {
            case 'LI':
              shipping1El = bottomElContainer.querySelector('.oa-header_shipping1-text');
              if (shipping1El) {
                shipping1El.innerText = 'Kostenloser Standard Versand ab 90 €';
              }
              shipping2El = bottomElContainer.querySelector('.oa-header_shipping2-text');
              if (shipping2El) {
                shipping2El.closest('.swiper-slide').remove();
              }
              break;
          case 'CH':
            shipping1El = bottomElContainer.querySelector('.oa-header_shipping1-text');
            if (shipping1El) {
              shipping1El.innerText = 'Kostenloser Express Versand ab 150 €';
            }
            shipping2El = bottomElContainer.querySelector('.oa-header_shipping2-text');
            if (shipping2El) {
              shipping2El.closest('.swiper-slide').remove();
            }
            break;
        }
      } else if (classList.contains('oa-uk')) {
        /* switch (data.country_code) {
          default:
            var loyaltyClubEl;
            loyaltyClubEl = bottomElContainer.querySelector('.img-bestpoints');
             if (loyaltyClubEl) {
              loyaltyClubEl.closest('.swiper-slide').remove();
            }
            break;
        } */
      } else if (classList.contains('oa-eu')) {
        switch (data.country_code) {
          case 'FR':
          case 'IE':
            shipping1El = bottomElContainer.querySelector('.oa-header_shipping1-text');
            if (shipping1El) {
              shipping1El.innerText = 'Free standard shipping for orders over €59';
            }
            shipping2El = bottomElContainer.querySelector('.oa-header_shipping2-text');
            if (shipping2El) {
              shipping2El.innerText = 'Free express shipping for orders over €99';
            }
            break;
          default:
            shipping2El = bottomElContainer.querySelector('.oa-header_shipping2-text');
            if (shipping2El) {
              shipping2El.closest('.swiper-slide').remove();
            }
            break;
        }
      } else if (classList.contains('oa-com')) {
        switch (data.country_code) {
          case 'CN':
            shipping1El = bottomElContainer.querySelector('.oa-header_shipping1-text');
            if (shipping1El) {
              shipping1El.closest('.swiper-slide').remove();
            }
            break;
        }
      }
      bottomEl.style.opacity = 1;
      if (swiper) {
        swiper.update(); 
      }
    });

    setTimeout(initSlider, 1000);

    window.addEventListener('resize', function () {
      initSlider();
    }, { passive: true });

  }, { passive: true });
})();

//
// BLOG
//
document.addEventListener('DOMContentLoaded', function () {
  if (document.body.classList.contains('oa-blog')) {
    var selectorMainLink = '.oa-hdr19-main__left__link',
        classMainLinkActive = 'oa-hdr19-main__left__link--active',
        mouseOutDelay = 250;

    var mainLeftLinks,
        activeLeftLink,
        mouseOutTimer;

    mainLeftLinks = Array.prototype.slice.call(document.querySelectorAll(selectorMainLink));

    activeLeftLink = mainLeftLinks.filter(function (element) {
      return element.classList.contains(classMainLinkActive);
    })[0];

    function resetMainTimeout () {
      if (mouseOutTimer) { 
        clearTimeout(mouseOutTimer);
      }
    }

    function onMainLeftLinkMouseEnter (element) {
      resetMainTimeout();
      mainLeftLinks.forEach(function (e) {
        if (e !== element && e.classList.contains(classMainLinkActive)) { 
          e.classList.remove(classMainLinkActive); 
        }
      });
      element.classList.add(classMainLinkActive);
    }

    function onMainLeftLinkMouseLeave () {
      resetMainTimeout();
      mouseOutTimer = setTimeout(function () {
        resetMainTimeout();
        mainLeftLinks.forEach(function (e) {
          if (e.classList.contains(classMainLinkActive)) { 
            e.classList.remove(classMainLinkActive); 
          }
        });
        if (typeof activeLeftLink !== 'undefined') {
          activeLeftLink.classList.add(classMainLinkActive);
        }
      }, mouseOutDelay);
    }

    mainLeftLinks.forEach(function (element) {
      element.addEventListener('mouseenter', onMainLeftLinkMouseEnter.bind(null, element), { passive: true });
      element.addEventListener('mouseleave', onMainLeftLinkMouseLeave, { passive: true });
    });
  }
}, { passive: true });

//
// TRANSPARENCY
//
var transparency = (function () {
  var elContentOffset,
      classTransparent = 'oa-hdr19--transparent',
      initialized = false,
      y = 0,
      o = 150;

  var throttledResize = throttle(50, handleResize);
  var throttledScroll = throttle(50, handleScroll);

  function hasClass() {
    return header.classList.contains(classTransparent);
  }

  function handleResize() {
    if (elContentOffset) {
      o = elContentOffset.offsetTop + 10 - header.offsetHeight;
    }
  }

  function handleScroll() {
    y = window.scrollY || window.pageYOffset;
    if (y >= o) {
      if (hasClass()) {
        header.classList.remove(classTransparent);
      }
    } else {
      if (!hasClass()) {
        header.classList.add(classTransparent);
      }
    }
  }

  function init() {

  }

  function enable(element) {
    if (element) {
      elContentOffset = element;
    }

    

    handleResize();
    handleScroll(); 
    if (initialized) {
      return; 
    }
    initialized = true;
    window.addEventListener('resize', throttledResize, { passive: true });
    window.addEventListener('scroll', throttledScroll, { passive: true });
  }

  function disable() {
    if (!initialized) return;
    window.removeEventListener('resize', throttledResize);
    window.removeEventListener('scroll', throttledScroll);
    initialized = false;
  }

  return {
    enable: enable,
    disable: disable
  };
})();

//
// RECHARGE FIX
//
document.addEventListener('DOMContentLoaded', function () {
  if (window.location.pathname.indexOf('/tools/recurring') !== -1) {
    var ids = ['#header-sidenav', '#oa-hdr19-banner', '#oa-hdr19'],
        selector = ids.map(function(id) { return id + ' [href*="/tools/recurring"]'; }).join(', ');
    Array.prototype.slice.call(document.querySelectorAll(selector)).forEach(function(el) {
      el.href = el.href.replace(/.*#/, '#').replace(/&.*/, '');
    });
  }
if(window.location.pathname == '/' && $('html').hasClass('header-version--a')){
  window.oaHeader.enableTransparency(document.querySelector('.oa-hero-banner .oa-hero-banner__content .h2'));
}else {
  $('.oa-hdr19').removeClass('oa-hdr19--transparent');
  $('.oa-content').removeClass('oa-content--transparent-header')
  window.oaHeader.disableTransparency();
}

const flyoutElements = document.querySelectorAll('.header-version--a .oa-hdr19-main__flyout__right');

const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    if (
      mutation.type === 'attributes' &&
      mutation.attributeName === 'class'
    ) {
      const el = mutation.target;

      // Check if it's becoming active
      const isNowActive = el.classList.contains('oa-hdr19-main__flyout__right--active');
     
      const innerLeft = el.querySelector('.oa-hdr19-main__flyout__inner-left');
      const noImgAnimation = el.querySelector('.oa-hdr19-main__flyout__right--img').classList.contains('oa-hdr19-main__flyout__right--img--no-animation');
      const img = el.querySelectorAll('.oa-hdr19-main__flyout__right--img .oa-picture-wrapper');
      
      

      document.querySelectorAll('.oa-hdr19-main__flyout__right').forEach(flyout => {
        if (!flyout.classList.contains('oa-hdr19-main__flyout__right--active')) {
          const otherInnerLeft = flyout.querySelector('.oa-hdr19-main__flyout__inner-left');
          if (otherInnerLeft) {
            otherInnerLeft.style.visibility = '';
          }
        }
      });

      if (isNowActive && innerLeft.style.visibility !== 'visible') {
        if (innerLeft) {
          innerLeft.style.visibility = 'visible';
          gsap.fromTo(innerLeft, 
            { opacity: 0, },
            { opacity: 1, duration: 0.8, ease: 'power2.out' }
          );
        }
 if (!noImgAnimation && img.length){
        gsap.fromTo(
          img,
          {
            height: 0,
            clipPath: 'inset(50% 0 50% 0)',
          },
          {
            height: '100%',         
            clipPath: 'inset(0% 0% 0% 0%)', 
            duration: 0.6,
            ease: 'power4.out',
          }
        );
      }
       
      if (el.querySelector('.oa-hdr19-main__flyout__right--img').classList.contains('oa-hdr19-main__flyout__right--img--animation')){
        el.querySelector('.oa-hdr19-main__flyout__right--img').classList.add('oa-hdr19-main__flyout__right--img--no-animation')
        
      }



      }

    }

  });
});

// Attach observer to all flyout elements
flyoutElements.forEach(flyout => {
  observer.observe(flyout, { attributes: true });
});




}, { passive: true });

return {
  setCountryIcon: chooseRegion.setCountryIcon,
  showCartCheck: cartBadge.showCheck,
  loadCartCount: cartBadge.loadCount,
  enableTransparency: transparency.enable,
  disableTransparency: transparency.disable
};

})();


window.setupHeaderVersion = function (version) {
         version='a';
      if(version == 'a'){
        $('.oa-hdr19-main--a').show(0);
        $('.oa-hdr19-main--b').hide(0);
      }else{

        $('.oa-hdr19-main--b').show(0);
        $('.oa-hdr19-main--a').hide(0);
        $('.oa-hdr19').removeClass('oa-hdr19--transparent');
        if (window.oaHeader && typeof window.oaHeader.disableTransparency === 'function') {
          window.oaHeader.disableTransparency();
        }
      }
      $('html').removeClass('header-version--a header-version--b');
      $('html').addClass('header-version--' + version); 

      $('.oa-hdr19').removeClass('oa-hdr19--version-a oa-hdr19--version-b');
      $('.oa-hdr19').addClass('oa-hdr19--version-' + version); 
    }


document.addEventListener('DOMContentLoaded', function () {
  if (window.location.hash === '#nav-a') {
    if (typeof window.setupHeaderVersion === 'function') {
      console.log('set nav a');
    }
  } else if (window.location.hash === '#nav-b') {
    if (typeof window.setupHeaderVersion === 'function') {
      window.setupHeaderVersion('b');
    }
  }
});